import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id FACF04CD-2633-47EC-97BE-59A3341289C3
 * name tray-remove
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tray-remove.svg
 * tags
 */
export const TrayRemoveIcon = createSvgIcon(<><path d="M2 17A2 2 0 0 0 4 19H20A2 2 0 0 0 22 17V12H20V17H4V12H2M14.12 5.46L15.54 6.88L13.41 9L15.54 11.12L14.12 12.54L12 10.41L9.88 12.54L8.46 11.12L10.59 9L8.46 6.88L9.88 5.46L12 7.59Z" /></>, 'TrayRemoveIcon');
export default TrayRemoveIcon